<template>
  <BaseModal :is-open="isOpen" close-on-outside-click @close="onClose">
    <div class="photo-modal">
      <BaseButtonIcon
        size="large"
        aria-label="Close Photo Modal"
        outline
        class="photo-modal__close-button"
        @click="onClose"
      >
        <ExitIcon />
      </BaseButtonIcon>

      <div class="photo-modal__content">
        <img :src="photo" class="photo-modal__content-image" alt="" />
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
import ExitIcon from '@/components/icon_components/ExitIcon.vue'
import BaseButtonIcon from '../base/BaseButtonIcon.vue'
import BaseModal from '../base/BaseModal.vue'

interface Props {
  photo?: string
  isOpen?: boolean
}

withDefaults(defineProps<Props>(), {
  photo: '',
  isOpen: true,
})

const emit = defineEmits<{
  (e: 'close'): void
}>()

const onClose = () => {
  emit('close')
}
</script>

<style lang="scss" scoped>
.photo-modal {
  position: relative;

  &__close-button {
    position: absolute;
    top: $spacing-s;
    right: $spacing-s;
  }

  &__content {
    display: flex;
    overflow: hidden;
  }

  &__content-image {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
  }
}
</style>
